import * as React from 'react'

import { useApolloClient } from '@apollo/client'
import {
  ShiftManagementAreasLocationsEmployeesDocument,
  ShiftManagementAreasViewPageDocument,
  ShiftManagementMainPageDocument,
} from 'generated/resources/graphql'

import { useOneMutationSubscription } from 'modules/ai/lib/useOneMutationSubscription'
import { useLazyFetchStats } from 'modules/shift_management/components/ShiftManagement/MainPage/useFetchStats'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'

const SHIFT_MANAGEMENT_SHOW_EVENT = 'shiftManagement.shifts.show'

export const ShiftManagementAiEventListener = () => {
  const apolloClient = useApolloClient()
  const [{ view }] = useSchedule()
  const { refetchData } = useLazyFetchStats()

  const handleApplyTemplate = React.useCallback(async () => {
    await refetchData()

    await apolloClient.refetchQueries({
      include: view.isByAreas
        ? [ShiftManagementAreasViewPageDocument, ShiftManagementAreasLocationsEmployeesDocument]
        : [ShiftManagementMainPageDocument],
    })
  }, [apolloClient, refetchData, view.isByAreas])

  useOneMutationSubscription('ShiftManagementScheduleApplyTemplate', handleApplyTemplate)

  React.useEffect(() => {
    const handleShow = (event: Event) => {
      event.preventDefault()

      void (async () => {
        await refetchData()

        await apolloClient.refetchQueries({
          include: view.isByAreas
            ? [ShiftManagementAreasViewPageDocument, ShiftManagementAreasLocationsEmployeesDocument]
            : [ShiftManagementMainPageDocument],
        })
      })()
    }

    window.addEventListener(SHIFT_MANAGEMENT_SHOW_EVENT, handleShow)

    return () => {
      window.removeEventListener(SHIFT_MANAGEMENT_SHOW_EVENT, handleShow)
    }
  }, [apolloClient, refetchData, view.isByAreas])

  return null
}
